function parseFieldStr (fieldstr) {
  const nestBeg = '{', nestEnd = '}'
  var i = 0
  var curIdent = ''
  var lastIdent = ''
  var curDepth = 0
  var stack = [{}]
  var c
  const newIdent = () => {
    if (curIdent) {
      lastIdent = curIdent
      stack[curDepth][lastIdent] = 1
      curIdent = ''
    }
  }
  while (i < fieldstr.length) {
    c = fieldstr.charAt(i)
    if (/\s/.test(c) || c === ',') {
      // separate identifiers
      newIdent()
    } else if (c === nestBeg) {
      newIdent()
      const newObj = stack[curDepth][lastIdent] = {}
      curDepth++
      stack[curDepth] = newObj
    } else if (c === nestEnd) {
      newIdent()
      if (curDepth > 0) {
        stack.splice(curDepth, 1)
        curDepth--
      } else {
        throw Error('Unmatched brace')
      }
    } else {
      curIdent = curIdent + c
    }
    i++
  }
  newIdent()
  return stack[0]
}

function serializeFieldStr (obj) {
  if (!obj) return ''
  const nestBeg = '{', nestEnd = '}'
  return Object.entries(obj)
    .filter(entry => entry[1])
    .map(entry => (
      typeof entry[1] === 'object'
        ? `${entry[0]}${nestBeg}${serializeFieldStr(entry[1])}${nestEnd}`
        : entry[0]
    ))
    .join(',')
}

function extractFields (obj) {
  if (obj instanceof Date) return 1
  const fields = {}
  for (const [key, value] of Object.entries(obj)) {
    if (key !== '_link') {
      let val = 1
      if (typeof value === 'object' && value) {
        if (!Array.isArray(value)) {
          val = extractFields(value)
        } else { // value is an array
          if (value.length > 0 && typeof value[0] === 'object' && value[0] !== null) {
            val = extractFields(value[0])
          }
        }
      }
      fields[key] = val
    }
  }
  return fields
}

function maskFields (obj, allFields, maskedFields = undefined) {
  let result = null
  for (const [key, value] of Object.entries(obj)) {
    if (key in allFields) {
      if (!result) {
        result = {}
      }
      if (typeof allFields[key] === 'number') {
        if (value) {
          result[key] = allFields[key]
        }
      } else if (typeof value === 'object') {
        if (key !== 'custom') {
          const childMasked = maskedFields && {}
          const nested = maskFields(value, allFields[key], childMasked)
          const childIncomplete = childMasked && Object.keys(childMasked).length
          if (nested) {
            result[key] = nested
          }
          if (maskedFields && childIncomplete) {
            maskedFields[key] = childMasked
          }
        } else { // key === 'custom'... carry across without masking
          result[key] = value
        }
      }
    } else {
      if (maskedFields) {
        maskedFields[key] = value
      }
    }
  }
  return result
}

function unionFields (fields1, fields2) {
  if (fields1 && typeof fields1 === 'object') {
    if (fields2 && typeof fields2 === 'object') { // both are objects
      const result = {}
      for (const [fieldName, fieldVal] of Object.entries(fields1)) {
        result[fieldName] = (fieldName in fields2) ? unionFields(fieldVal, fields2[fieldName]) : fieldVal
      }
      for (const [fieldName, fieldVal] of Object.entries(fields2)) {
        if (!(fieldName in fields1)) {
          result[fieldName] = fieldVal
        }
      }
      return result
    } else { // fields1 is object, fields2 is not
      return fields1
    }
  } else {
    if (fields2 && typeof fields2 === 'object') { // fields2 is object, fields1 is not
      return fields2
    } else { // neither are objects
      return fields1 || fields2
    }
  }
}

function unionAllFields (...args) {
  if (args.length) {
    return args.reduce((previous, current) => (
      !previous
        ? current
        : !current
          ? previous
          : unionFields(previous, current)
    ))
  }
}

function intersectFields (fields1, fields2, favorObjects = false) {
  if (fields1 && typeof fields1 === 'object') {
    if (fields2 && typeof fields2 === 'object') { // both are objects
      const result = {}
      for (const [fieldName, fieldVal] of Object.entries(fields1)) {
        if (fieldName in fields2) {
          result[fieldName] = intersectFields(fieldVal, fields2[fieldName], favorObjects)
        }
      }
      return result
    } else { // fields1 is object, fields2 is not
      return favorObjects ? fields1 : fields2
    }
  } else {
    if (fields2 && typeof fields2 === 'object') { // fields2 is object, fields1 is not
      return favorObjects ? fields2 : fields1
    } else { // neither are objects
      return fields2 || fields1
    }
  }
}

/**
 * Returns true if every named property of fieldsB is also a named property of fieldsA.
 * In other words, detects if fieldsB is a subset of fieldsA.
 * @param {object} fieldsA 
 * @param {object} fieldsB 
 * @return {boolean}
 */
function includesFields (fieldsA, fieldsB, recurse = true) {
  if (typeof fieldsA === 'undefined') return true
  if (typeof fieldsB === 'undefined') return false
  const specifiedA = fieldsA && typeof fieldsA === 'object'
  const specifiedB = fieldsB && typeof fieldsB === 'object'
  if (specifiedB) {
    if (specifiedA) {
      return recurse
        ? Object.entries(fieldsB).every((key, val) => includesFields(fieldsA[key], val, recurse))
        : Object.keys(fieldsB).every(key => (key in fieldsA))
    }
    return Boolean(fieldsA)
  }
  // (else) fieldsB is hardcoded (whether true or false)
  if (!specifiedA && fieldsA) { // if fieldsA is hardcoded true
    return Boolean(fieldsB) // return true if fieldsB is ALSO hardcoded true, otherwise false
  }
  // (else) fieldsA is either hardcoded false, or is specified but fieldsB is UNspecified
  return !fieldsB // return false if fieldsB is hardcoded true, otherwise return true if fieldsB is hardcoded false
}

function filterObjectFields (objValue, fieldMask) {
  if (!objValue) {
    console.error('Invalid objValue') // throw new TypeError('Invalid objValue')
    return undefined
  }
  if (!fieldMask) {
    // fieldMask is falsy -- don't let anything through filter
    return undefined
  } else if (typeof fieldMask !== 'object' || Object.keys(fieldMask).length === 0) {
    // fieldMask is either a truthy non-object, OR it's an object with no properties:
    // let the entire object value through the filter
    return objValue
  }
  let nextObjValue = {}
  for (const key in fieldMask) {
    if (key in objValue) {
      // handle answers for new selection variables that include cached object-type data
      const valueKey = ((key + '_$') in objValue) ? key + '_$' : key
      if (Array.isArray(objValue[valueKey])) {
        nextObjValue = ({
          ...nextObjValue,
          [key]: objValue[valueKey].map(r => typeof r === 'object' && r !== null
            ? filterObjectFields(r, fieldMask[key])
            : r
          ),
        })
      } else if (typeof fieldMask[key] === 'object') {
        nextObjValue = ({
          ...nextObjValue,
          [key]: (typeof objValue[valueKey] === 'object' && objValue[valueKey] !== null)
            ? filterObjectFields(objValue[valueKey], fieldMask[key])
            : objValue[key],
        })
      } else {
        nextObjValue = ({
          ...nextObjValue,
          [key]: objValue[valueKey] ? objValue[valueKey] : '',
        })
      }
    }
  }
  return nextObjValue
}

export {
  parseFieldStr,
  serializeFieldStr,
  extractFields,
  maskFields,
  unionFields,
  unionAllFields,
  intersectFields,
  includesFields,
  filterObjectFields,
}
